import axios from "axios";

const API_BASE = process.env.REACT_APP_API_URL || "";

const authClient = axios.create({
    baseURL: API_BASE,
    withCredentials: true
});

export async function login(email, password, totpCode = null) {
    const resp = await authClient.post(`/api/auth/login`, {
        email,
        password,
        totpCode
    });
    return resp.data;
}

export async function register(name, email, password) {
    const resp = await authClient.post(`/api/auth/register`, {
        name,
        email,
        password
    });
    return resp.data;
}

export async function refreshSession() {
    const resp = await authClient.post(`/api/auth/refresh`);
    return resp.data;
}

export async function logout() {
    const resp = await authClient.post('/api/auth/logout');
    return resp.data;
}

export async function getCurrentUser() {
    const resp = await authClient.get('/api/auth/me');
    return resp.data;
}

export async function verifyEmail(token) {
    const resp = await authClient.post('/api/auth/verify-email', { token });
    return resp.data;
}

export async function requestPasswordReset(email) {
    const resp = await authClient.post('/api/auth/password-reset/request', { email });
    return resp.data;
}

export async function confirmPasswordReset(token, newPassword) {
    const resp = await authClient.post('/api/auth/password-reset/confirm', { token, newPassword });
    return resp.data;
}

export async function changePassword(currentPassword, newPassword) {
    const resp = await authClient.post('/api/auth/password/change', { currentPassword, newPassword });
    return resp.data;
}

export async function deleteAccount(password, confirmation) {
    const resp = await authClient.delete('/api/auth/account', {
        data: { password, confirmation }
    });
    return resp.data;
}

// ==================== Two-Factor Authentication ====================

export async function get2FAStatus() {
    const resp = await authClient.get('/api/auth/2fa/status');
    return resp.data;
}

export async function setup2FA() {
    const resp = await authClient.post('/api/auth/2fa/setup');
    return resp.data;
}

export async function enable2FA(code) {
    const resp = await authClient.post('/api/auth/2fa/enable', { code });
    return resp.data;
}

export async function disable2FA(code) {
    const resp = await authClient.post('/api/auth/2fa/disable', { code });
    return resp.data;
}

export async function regenerateBackupCodes(code) {
    const resp = await authClient.post('/api/auth/2fa/backup-codes/regenerate', { code });
    return resp.data;
}

// ==================== Session Management ====================

export async function getSessions() {
    const resp = await authClient.get('/api/auth/sessions');
    return resp.data;
}

export async function revokeSession(sessionId) {
    const resp = await authClient.delete(`/api/auth/sessions/${sessionId}`);
    return resp.data;
}

export async function revokeAllSessions() {
    const resp = await authClient.delete('/api/auth/sessions/all');
    return resp.data;
}

export async function revokeOtherSessions(currentSessionId) {
    const resp = await authClient.delete(`/api/auth/sessions/others?currentSessionId=${currentSessionId}`);
    return resp.data;
}

// ==================== Device Management ====================

export async function getDevices() {
    const resp = await authClient.get('/api/auth/devices');
    return resp.data;
}

export async function removeDevice(deviceId) {
    const resp = await authClient.delete(`/api/auth/devices/${deviceId}`);
    return resp.data;
}

export async function trustDevice(deviceId) {
    const resp = await authClient.post(`/api/auth/devices/${deviceId}/trust`);
    return resp.data;
}